function openFaqChat(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  if (window.Reamaze && typeof window.Reamaze.popup === 'function') {
    window.Reamaze.popup();
    return;
  }

  if (window._support && window._support.ui && typeof window._support.ui.open === 'function') {
    window._support.ui.open();
    return;
  }

  const target = document.querySelector(
    '.sdusa-chat, .live-chat-link, .faq-a a, .sdusa-faq a, #ShopifyChat, #shopify-chat, .shopify-chat-button, [data-shopify-chat-button], .support-chat-button, [data-support-widget]'
  );
  if (target) {
    const clickable = target.closest('button') || target;
    if (typeof clickable.click === 'function') {
      clickable.click();
    }
  }
}

function convertLiveChatText(answer) {
  if (!answer || answer.dataset.chatConverted === 'true') return;
  answer.dataset.chatConverted = 'true';

  const walker = document.createTreeWalker(answer, NodeFilter.SHOW_TEXT, null);
  const matches = [];
  let node;

  while ((node = walker.nextNode())) {
    if (
      /live chat/i.test(node.nodeValue) &&
      !(node.parentNode && node.parentNode.classList && node.parentNode.classList.contains('sdusa-chat'))
    ) {
      matches.push(node);
    }
  }

  matches.forEach((textNode) => {
    const fragment = document.createDocumentFragment();
    textNode.nodeValue.split(/(live chat)/gi).forEach((part) => {
      if (/^live chat$/i.test(part)) {
        const link = document.createElement('a');
        link.href = '#';
        link.className = 'sdusa-chat faq-a';
        link.textContent = 'Live Chat';
        fragment.appendChild(link);
      } else if (part) {
        fragment.appendChild(document.createTextNode(part));
      }
    });
    if (textNode.parentNode) {
      textNode.parentNode.replaceChild(fragment, textNode);
    }
  });
}

function initFaqSections() {
  const sections = document.querySelectorAll('.faq-section');
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.faqInitialized === 'true') return;
    section.dataset.faqInitialized = 'true';

    section.addEventListener('click', function (event) {
      // 1. Accordion Question Click
      const btn = event.target.closest('.faq-question-btn');
      if (btn) {
        const item = btn.closest('.faq-item');
        if (!item) return;

        const answer = item.querySelector('.faq-answer-wrapper');
        const isOpen = item.classList.contains('active');
        const allItems = section.querySelectorAll('.faq-item');

        // Close other items in this section
        allItems.forEach((otherItem) => {
          if (otherItem === item) return;
          otherItem.classList.remove('active');
          const otherBtn = otherItem.querySelector('.faq-question-btn');
          const otherAnswer = otherItem.querySelector('.faq-answer-wrapper');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          if (otherAnswer) {
            otherAnswer.setAttribute('aria-hidden', 'true');
            otherAnswer.inert = true;
            otherAnswer.style.maxHeight = '0px';
          }
        });

        // Toggle clicked item
        if (isOpen) {
          item.classList.remove('active');
          btn.setAttribute('aria-expanded', 'false');
          if (answer) {
            answer.setAttribute('aria-hidden', 'true');
            answer.inert = true;
            answer.style.maxHeight = '0px';
          }
        } else {
          item.classList.add('active');
          btn.setAttribute('aria-expanded', 'true');
          if (answer) {
            convertLiveChatText(answer);
            answer.setAttribute('aria-hidden', 'false');
            answer.inert = false;
            answer.style.maxHeight = `${answer.scrollHeight + 40}px`;
          }
        }
        return;
      }

      // 2. Link & Live Chat Click Delegation
      const link = event.target.closest('a');
      if (link) {
        const linkText = (link.textContent || '').trim().toLowerCase();
        const href = (link.getAttribute('href') || '').trim();

        const isLiveChat =
          link.classList.contains('sdusa-chat') ||
          linkText.includes('live chat') ||
          linkText.includes('chat en vivo') ||
          href.includes('live-chat') ||
          (href.includes('/pages/faq') && linkText.includes('chat'));

        if (isLiveChat) {
          openFaqChat(event);
          return;
        }

        if (!link.hasAttribute('target') && href !== '#' && href !== '') {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      }
    });
  });
}

// ReadyState guard
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqSections, { once: true });
} else {
  initFaqSections();
}

document.addEventListener('shopify:section:load', initFaqSections);
document.addEventListener('shopify:section:select', initFaqSections);
